import { useNavigate, useLocation } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../components/ui/card";
import { Clock, CheckCircle, Mail } from "lucide-react";

const PendingApproval = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || "your email";
  const clubName = location.state?.clubName || "your club";

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-amber-50 via-red-50 to-amber-100 p-4">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(251,191,36,0.1),transparent_50%),radial-gradient(circle_at_70%_80%,rgba(220,38,38,0.1),transparent_50%)]" />
      
      <Card className="w-full max-w-lg relative z-10 shadow-2xl border-amber-100">
        <CardHeader className="space-y-4 text-center">
          <div className="mx-auto w-24 h-24 bg-amber-100 rounded-full flex items-center justify-center">
            <Clock className="w-12 h-12 text-amber-600 animate-pulse" />
          </div>
          <div>
            <CardTitle className="text-3xl font-bold text-amber-600">Account Pending Approval</CardTitle>
            <CardDescription className="text-base mt-3">Your volunteer account has been created successfully!</CardDescription>
          </div>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="bg-white border-2 border-amber-200 rounded-lg p-6 space-y-4">
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-semibold text-gray-800 mb-1">Registration Details</p>
                <p className="text-sm text-gray-600">Email: <span className="font-mono text-blue-600">{email}</span></p>
                <p className="text-sm text-gray-600">Club: <span className="font-semibold">{clubName}</span></p>
              </div>
            </div>
            
            <div className="flex items-start gap-3">
              <CheckCircle className="w-5 h-5 text-amber-600 mt-0.5 flex-shrink-0" />
              <div>
                <p className="font-semibold text-gray-800 mb-1">What Happens Next?</p>
                <p className="text-sm text-gray-600">Your club supervisor will review your application and verify your details.</p>
              </div>
            </div>
          </div>

          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 space-y-2">
            <p className="text-sm font-semibold text-amber-800">⏳ Waiting for Approval</p>
            <p className="text-sm text-gray-700">
              You will be able to login once your supervisor approves your account. 
              This usually takes 1-2 business days.
            </p>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 space-y-2">
            <p className="text-sm font-semibold text-blue-800">📧 What if I don't hear back?</p>
            <p className="text-sm text-gray-700">
              If you haven't received approval within 3 days, please contact your club supervisor directly.
            </p>
          </div>

          <Button 
            onClick={() => navigate("/login")}
            data-testid="go-to-login-button"
            className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-6 rounded-full shadow-lg hover:shadow-xl"
          >
            Go to Login Page
          </Button>

          <p className="text-center text-xs text-gray-500">
            You'll receive an email notification once your account is approved.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default PendingApproval;
